export default () => {
    return useCookie<string>('uid', {
        maxAge: 2592000, // 30 days
        secure: true,
    })
}
